import { useState, forwardRef, useEffect } from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Typography } from "@mui/material";
import Checkbox from "../../../components/shared/checkbox/Checkbox";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const MultiSelectQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      myAnswer,
      isEdit,
      latestStepQuestion,
      handleCurrentQuestion,
    },
    ref
  ) => {
    const [checked, setChecked] = useState({});
    const [noValue, setNoValue] = useState("");
    const [choices, setChoices] = useState([]);
    const [show, setShow] = useState(false);
    const [errorInput, setErrorInput] = useState(false);

    const isMobile = useMediaQuery("(max-width:900px)");

    useEffect(() => {
      setChecked(myAnswer);
      const keysWithNonZeroValues = Object.keys(myAnswer).filter(
        (key) => myAnswer[key] !== 0
      );
      setChoices(keysWithNonZeroValues);
    }, [myAnswer]);

    // useEffect(() => {
    //   console.log({ checked, choices });
    // }, [checked, choices]);

    const handleMultiValue = (value, choise) => {
      handleCurrentQuestion(data?.id);
      if (value === "i_dont_know") {
        setChecked({
          ransomware: 0,
          dos: 0,
          supply_chain: 0,
          data_breaches: 0,
          social_engineering: 0,
          no_attack: 0,
          i_dont_know: 1,
        });
        setNoValue(value);
        setChoices(["i_dont_know"]);
      } 
      else if ( value === "no_attack") {
        setChecked({
          ransomware: 0,
          dos: 0,
          supply_chain: 0,
          data_breaches: 0,
          social_engineering: 0,
          no_attack:1,
          i_dont_know: 0,
        });
        setNoValue(value);
        setChoices(["no_attack"]);
      }else {
        setNoValue("");
        setChoices(
          !choices.includes(value)
            ? [...choices, value].filter((el) => el !== "no_attack" && el !== "i_dont_know")
            : choices.filter((el) => el !== value)
        );
      }
      setShow(false);
    };

    const nextQuestionHandler = (height, value) => {
      scrollToQuestion(data, height, value);
      handlePayload(data, value);
      setErrorInput(false);
    };
    const { t } = useTranslation();

    useEffect(() => {
        if (checked.i_dont_know === 1 || checked.no_attack === 1 ) {
          data.nextQuestion = 21;
          data.nextStepQuestion = null;
        } else {
          data.nextQuestion = 20; 
          data.nextStepQuestion = 20;
        }
     
    }, [checked]);
      

    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data?.question)}</Typography>
          <Grid container spacing={2} m={0} alignItems="center">
            {data?.choises.map((choise, index) => (
              <>
                <Grid item xs={choise.xs} lg={choise.lg} key={`check${index}`}>
                  <Checkbox
                    title={t(choise.key)}
                    id={choise.id}
                    checked={
                      choices?.includes(choise.key) || noValue === choise.key 
                    }
                    value={choise.key}
                    nextQuestionHandler={(value) => {
                      handleMultiValue(value, choise);
                    }}
                  />
                </Grid>
                <Grid item xs={choise.xs} lg={choise.lg} key={`check${index}`}>
                  {choise.key !== "i_dont_know" &&
                    choise.key !== "no_attack" &&
                    choices?.includes(choise.key) && (
                      <TextField
                        id="outlined-basic"
                        placeholder={t("nbre_incidents")}
                        variant="outlined"
                        type="Number"
                        error={errorInput && checked[choise.key] === 0}
                        fullWidth
                        helperText={
                          errorInput && 
                          checked[choise.key] === 0 &&
                          t("required_field")
                        }
                        value={checked[choise.key]!== 0 &&checked[choise.key]}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          if (value >= 0) {
                            setChecked({
                              ...checked,
                              [choise.key]: value, no_attack:0,i_dont_know:0
                            });
                          }
                        }}
                        InputProps={{                       
                          sx: {
                              '& input[type=number]': {
                                  MozAppearance: 'textfield', // Firefox
                                  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                      display: 'none',  // Chrome, Safari, Edge
                                  },
                              },
                          },
                      }}
                      />
                    )}
                </Grid>
              </>
            ))}
          </Grid>
          {show && (
            <span className="error-message-autocomplete">
              {t("required_field")}
            </span>
          )}

          {currentQuestion === data?.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data?.id) || (checked !== myAnswer) ? (
            <>
              {" "}
              <Button
                onClick={(option) => {
                  noValue === "" && choices.length === 0
                    ? setShow(true)
                    : choices.some((el) => checked[el] === 0)
                    ? setErrorInput(true)
                    : nextQuestionHandler(ref.current.clientHeight, checked);
                  ;
                }}
                disabled={Object.values(checked).every(value => value === 0)}
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default MultiSelectQuestion;
